import { apiClient } from './apiClient';

/**
 * Per-ACCOUNT Google OAuth *client* credentials (Admin → Integrations → Google
 * Calendar). Lets a clinic point the calendar sync at its own verified Google
 * app; the sync falls back to the platform default client when unset. Distinct
 * from googleCalendar.service.ts, which is the per-USER connect/sync flow.
 */
export interface GoogleCalendarClientCredentials {
  /** OAuth client id (not secret — shown in full). */
  clientId: string;
  /** OAuth client secret (masked by the API; send blank to keep the stored one). */
  clientSecret: string;
}

export interface GoogleCalendarSettingsResponse {
  configured: boolean;
  credentials: GoogleCalendarClientCredentials;
}

export async function getGoogleCalendarClientSettings(): Promise<GoogleCalendarSettingsResponse> {
  const res = await apiClient.get<{ data: GoogleCalendarSettingsResponse }>('/admin/google-calendar-settings');
  return res.data.data;
}

export async function updateGoogleCalendarClientSettings(
  credentials: Partial<GoogleCalendarClientCredentials>,
): Promise<GoogleCalendarSettingsResponse> {
  const res = await apiClient.put<{ data: GoogleCalendarSettingsResponse }>(
    '/admin/google-calendar-settings',
    credentials,
  );
  return res.data.data;
}
